export default "__VITE_ASSET__BHa15KeA__"